export default "__VITE_ASSET__11752b3e__"